import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Menu, Dropdown, Image, Button } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { clearSearch } from "../actions";
import Search from "./search";

const ListMenu = ({ includeSearch }) => {
  const dispatch = useDispatch();

  const search = useSelector((state) => state.search);
  const retailers = useSelector((state) => state.retailers);
  const retailer = useSelector((state) => state.retailer);
  const user = useSelector((state) => state.user);

  const [retailerName, setRetailerName] = useState();

  const templates = retailers.filter((item) => {
    return item.name === retailer;
  });

  useEffect(() => {
    const rn = _.find(retailers, (item) => {
      return item.name === retailer;
    });
    if (rn) setRetailerName(rn.displayName);
  }, [retailer, retailers]);

  return (
    <Menu attached="top">
      {templates.length && templates[0].logo && (
        <>
          <Menu.Item className="retailer-logo">
            <NavLink to={`/${retailer}/list/1`}>
              <Image src={templates[0].logo} size="tiny" />
            </NavLink>
          </Menu.Item>
          <Menu.Item>{retailerName}</Menu.Item>
        </>
      )}
      {templates.length && (
        <Dropdown item text="Templates" simple>
          <Dropdown.Menu>
            {templates &&
              templates[0].templates.map((template) => {
                return (
                  <Dropdown.Item key={template.name}>
                    <NavLink to={`/${retailer}/new/${template.name}`}>
                      {template.displayName} template
                    </NavLink>
                  </Dropdown.Item>
                );
              })}
          </Dropdown.Menu>
        </Dropdown>
      )}
      {retailer === "tesco" && user.organisation === "dunnhumby" && (
        <Menu.Item>
          <NavLink to={`/${retailer}/sku-checker`} size="tiny" type="button">
            Search lookup
          </NavLink>
        </Menu.Item>
      )}
      {(retailer === "tesco" || retailer === "tesco_ie") &&
        user.organisation === "dunnhumby" && (
          <Menu.Item>
            <NavLink
              to={`/${retailer}/range-checker`}
              size="tiny"
              type="button"
            >
              Range lookup
            </NavLink>
          </Menu.Item>
        )}
      {search.type && (
        <>
          <Menu.Item>Results for {search.term} </Menu.Item>
          <Menu.Item>
            <Button
              type="button"
              onClick={() => dispatch(clearSearch())}
              size="tiny"
            >
              Reset
            </Button>
          </Menu.Item>
        </>
      )}
      {includeSearch && (
        <Menu.Menu position="right">
          <Search />
        </Menu.Menu>
      )}
    </Menu>
  );
};

export default ListMenu;
